import { IRootState } from '../../../store'
import { ICameraAttachmentsState } from '../store/cameraAttachments.types'

export const getCameraAttachmentsSelector = (state: IRootState): ICameraAttachmentsState => state.cameraAttachments
